export default __webpack_public_path__ + "static/media/g-xxl-2.8102c94b.png";